import PaymentError from './PaymentError.js'

export default class InvalidTaxError extends PaymentError {}
